export const SET_INDEX = "SET_INDEX";
export const SET_APP_STATUS = "SET_APP_STATUS";
export const SET_APP_PROGRESS = "SET_APP_PROGRESS";
export const SET_APP_CLEAN_STATUS = "SET_APP_CLEAN_STATUS";
export const SET_SEARCH = "SET_SEARCH";

export const SET_LOGIN_DATA = "SET_LOGIN_DATA";
export const SET_USER_CENTER_INFO = "SET_USER_CENTER_INFO";
export const SET_USER_CHECK_IN_STATUS = "SET_USER_CHECK_IN_STATUS";
export const SET_USER_CENTER_CURRENT_NAV = "SET_USER_CENTER_CURRENT_NAV";

export const SET_ORDER_PAGE = "SET_ORDER_PAGE";
export const SET_ORDER_LIST = "SET_ORDER_LIST";
// export const SET_ORDER_LIST_SINGLE = "SET_ORDER_LIST_SINGLE";
// export const CLEAR_PURCHASE_LATEST_ORDER = "CLEAR_PURCHASE_LATEST_ORDER";

export const SET_ORDER_LIST_CURRENT_NAV = "SET_ORDER_LIST_CURRENT_NAV";
export const SET_ORDER_LIST_MALL_TAB = "SET_ORDER_LIST_MALL_TAB";

export const SET_SOFT_INFO = "SET_SOFT_INFO";
export const SET_POLLS = "SET_POLLS";
export const SET_MY_SCORE = "SET_MY_SCORE";
export const SET_MY_LEVEL = "SET_MY_LEVEL";
export const SET_CURRENT_TAB = "SET_CURRENT_TAB";
export const SET_REPLY_DATA = "SET_REPLY_DATA";
export const SET_COMMENT_DATA = "SET_COMMENT_DATA";
export const SET_COMMENT_TYPE = "SET_COMMENT_TYPE";
export const SET_COMMENT_LIST = "SET_COMMENT_LIST";
export const SET_COMMENT_PAGE = "SET_COMMENT_PAGE";
export const SET_COMMENT_FORCE_UPDATE = "SET_COMMENT_FORCE_UPDATE";

export const SET_MY_COMMENT = "SET_MY_COMMENT";
export const SET_ACCOUNT_TIP = "SET_ACCOUNT_TIP";
export const SET_MALL_DATA = "SET_MALL_DATA";
export const SET_FAIL_ORDER = "SET_FAIL_ORDER";

export const SET_MALL_PAY = "SET_MALL_PAY";
export const SET_EXPIRE_TIME = "SET_EXPIRE_TIME";
export const SET_MALL_ITEM = "SET_MALL_ITEM";
export const SET_MALL_ORDER = "SET_MALL_ORDER";
export const SET_MALL_ORDER_INFO = "SET_MALL_ORDER_INFO";
export const SET_SUBMIT_SKUID = "SET_SUBMIT_SKUID";

export const SET_GAME_DATA = "SET_GAME_DATA";

export const SET_RANK_BANNER = "SET_RANK_BANNER";
export const SET_RANK_LIST = "SET_RANK_LIST";

export const SET_GAME_AREA_DATA = "SET_GAME_AREA_DATA";

export const SET_PRICE_DATA = "SET_PRICE_DATA";
export const SET_IS_HIDDEN = "SET_IS_HIDDEN";

export const SET_COM_DATA = "SET_COM_DATA";
